export const StepByIndustry = new Map([]);